<template>
  <div>
    <b-row class="match-height">
      <b-col md="12" lg="3">
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">{{$t('campaigns.dateCampaign')}}</h3>
            <b-button
              variant="flat-primary"
              class="btn-icon"
              @click="showEdit('dates')"
              :disabled="disabled_update"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
          <b-row class="mt-1">
            <b-col md="12" lg="5">
              <h4 class="mb-0"><strong>{{ campaign.init_date }}</strong></h4>
              <p>{{$t('campaigns.startDate')}}</p>
            </b-col>
            <b-col md="12" lg="2">
              <h4 class="mb-0"><strong>-</strong></h4>
            </b-col>
            <b-col md="12" lg="5">
              <h4 class="mb-0"><strong>{{ campaign.end_date }}</strong></h4>
              <p>{{$t('campaigns.finishDate')}}</p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="12" lg="3">
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">{{$t('campaigns.Budget')}}</h3>
            <b-button
              variant="flat-primary"
              class="btn-icon"
              @click="showEdit('budget')"
              :disabled="disabled_update"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
          <h4 class="mt-1"><strong>$ {{ separatebycomma(campaign.budget) }}</strong></h4>
        </b-card>
      </b-col>
      <b-col md="12" lg="3" v-if="role !== 'realty'">
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">{{$t('campaigns.brand')}}</h3>
            <span id="btn-edit-brand-wrapper" :style="!is_editable_by_api ? 'cursor: not-allowed; display: inline-block;' : ''">
              <b-button
                variant="flat-primary"
                class="btn-icon"
                @click="showEdit('brand')"
                :disabled="disabled_update || !is_editable_by_api"
                :style="!is_editable_by_api ? 'pointer-events: none;' : ''"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </span>
            <b-tooltip v-if="!is_editable_by_api" target="btn-edit-brand-wrapper" variant="primary" :title="$t('campaigns.not_editable_collaborations')" />
          </div>
          <h4 class="mt-1"><strong>{{ brand_reference_name }}</strong></h4>
        </b-card>
      </b-col>
      <b-col md="12" lg="3" v-if="role !== 'realty'">
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">{{$t('campaigns.whatsappBrand')}}</h3>
            <b-button
              variant="flat-primary"
              class="btn-icon"
              @click="showEdit('whats')"
              :disabled="disabled_update"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
          <h4 class="mt-1"><strong>{{ `${code ? code : ''} ${whatsapp_manager}` }}</strong></h4>
        </b-card>
      </b-col>
    </b-row>

    <!-- Canal de YouTube -->
    <b-row v-if="role !== 'realty' && can_use_youtube">
      <b-col md="12" lg="6">
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">Canal de YouTube</h3>
            <!-- Botón deshabilitado + tooltip cuando is_editable_by_api es false -->
            <span
              v-if="!is_editable_by_api"
              id="btn-edit-youtube-wrapper"
              style="cursor: not-allowed; display: inline-block;"
            >
              <b-button
                variant="flat-primary"
                class="btn-icon"
                disabled
                style="pointer-events: none;"
              >
                <feather-icon icon="EditIcon" />
              </b-button>
            </span>
            <!-- Botón editar normal cuando is_editable_by_api es true y ya hay canal -->
            <b-button
              v-else-if="campaign.channel_brand_youtube"
              variant="flat-primary"
              class="btn-icon"
              @click="openYoutubeModal()"
              :disabled="disabled_update"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-tooltip
              v-if="!is_editable_by_api"
              target="btn-edit-youtube-wrapper"
              variant="primary"
              :title="$t('campaigns.not_editable_collaborations')"
            />
          </div>

          <!-- Canal asignado -->
          <div v-if="campaign.channel_brand_youtube" class="mt-1 d-flex align-items-center">
            <b-avatar size="32" class="mr-1 p-25" style="background: #ff0000;">
              <b-img :src="youtubeIcon" fluid />
            </b-avatar>
            <strong>{{ campaign.channel_brand_youtube }}</strong>
          </div>

          <!-- Sin canal + editable: botón de asignar -->
          <div v-else-if="is_editable_by_api && !disabled_update" class="mt-1">
            <b-button variant="outline-primary" size="sm" @click="openYoutubeModal()">
              <feather-icon icon="PlusIcon" size="14" class="mr-50" />
              Asignar canal
            </b-button>
          </div>

          <!-- Sin canal + no editable -->
          <div v-else class="mt-1">
            <span class="text-muted">Sin canal asignado</span>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="role !== 'realty'">
      <b-col>
        <b-card>
          <div class="d-flex align-items-center">
            <h3 class="mb-0 blueC">{{$t('campaigns.messageInvitation')}}</h3>
            <b-button
              variant="flat-primary"
              class="btn-icon"
              @click="showEdit('invitation')"
              :disabled="disabled_update"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
          </div>
          <div class="plusGrand" v-html="campaign.custom_message"></div>
        </b-card>
      </b-col>
    </b-row>

    <modal-brandme :show_modal="show_modal_dates" :key="`modal_dates_${change_modal_dates}`">
      <template #title>{{$t('campaigns.validityCampaign')}}</template>
      <template #body>
        <div class="w-100 d-flex">
          <div class="mr-2 w-p-48">
            <label>{{$t('campaigns.startDate')}}</label>
            <b-form-datepicker
              id="fecha-inicio"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              v-model="init_date"
              class="mb-1"
            />
          </div>
          <div class="w-p-48">
            <label>{{$t('campaigns.finishDate')}}</label>
            <b-form-datepicker
              id="fecha-final"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              v-model="end_date"
              class="mb-1"
            />
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('dates')">{{$t('campaigns.close')}}</b-button>
          <b-button variant="primary" @click="updateDates()">{{$t('dashboard.save')}}</b-button>
        </div>
      </template>
    </modal-brandme>

    <modal-brandme :show_modal="show_modal_budget" :key="`modal_budget_${change_modal_budget}`">
      <template #title>{{$t('campaigns.budgetChange')}}</template>
      <template #body>
        <b-input-group prepend="$">
          <cleave
            v-model="budget"
            :options="options_number"
            class="form-control"
            :raw="false"
            :maxlength="10"
            @input="validateBudget"
          />
        </b-input-group>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('budget')">{{$t('campaigns.close')}}</b-button>
          <b-button variant="primary" @click="updateBudget()">{{$t('dashboard.save')}}</b-button>
        </div>
      </template>
    </modal-brandme>

    <modal-brandme :show_modal="show_modal_brand" :key="`modal_brand_${change_modal_brand}`">
      <template #title>{{$t('campaigns.validityCampaign')}}</template>
      <template #body>
        <b-form-group>
          <v-select
            v-model="brand"
            label="title"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="brands"
          />
        </b-form-group>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('brand')">{{$t('campaigns.close')}}</b-button>
          <b-button variant="primary" @click="updateBrand()">{{$t('dashboard.save')}}</b-button>
        </div>
      </template>
    </modal-brandme>

    <modal-brandme :show_modal="show_modal_whats" :key="`modal_whats_${change_modal_whats}`">
      <template #title>{{$t('campaigns.editWhatsApp')}}</template>
      <template #body>
            <b-form-group>
              <label for="telephone">{{$t('telephone')}}</label>
              <input-tel-brandme
                :country_dad="country ? country : 'MX'"
                :number_dad="whatsapp_manager"
                @number="updateTelephone"
              ></input-tel-brandme>
            </b-form-group>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('whats')">{{$t('campaigns.close')}}</b-button>
          <b-button variant="primary" @click="updateWhatsApp()" :disabled="!state_telephone">{{$t('dashboard.save')}}</b-button>
        </div>
      </template>
    </modal-brandme>

    <!-- Modal Canal de YouTube -->
    <modal-brandme v-if="can_use_youtube" :show_modal="show_modal_youtube" :key="`modal_youtube_${change_modal_youtube}`">
      <template #title>Canal de YouTube</template>
      <template #body>
        <p class="text-muted font-small-3 mb-1">Selecciona la cuenta de YouTube de la marca para esta campaña.</p>

        <div v-if="loadingYoutubeNetworks" class="text-center py-2">
          <b-spinner small variant="primary" />
        </div>

        <div v-else-if="youtubeNetworks.length === 0">
          <div v-if="!addingManual">
            <b-button class="google-yt-btn w-100 mb-1" @click="youtubeLoginWizard()">
              <b-img :src="googleIcon" class="google-yt-btn__icon" />
              <span>Conectar con Google</span>
            </b-button>
            <p v-if="oauthOpened" class="text-muted font-small-3 text-center mb-1">
              Completa el proceso en la ventana que se abrió y después
              <b-link @click="refreshYoutubeNetworks()">recarga las cuentas</b-link>.
            </p>
            <div class="yt-divider my-1"><span>o</span></div>
            <b-button variant="outline-secondary" class="w-100" @click="addingManual = true">
              <feather-icon icon="EditIcon" size="14" class="mr-50" />
              Ingresar manualmente
            </b-button>
          </div>
          <div v-else>
            <b-button variant="flat-secondary" size="sm" class="mb-1 p-0" @click="addingManual = false; youtubeChannelError = null">
              <feather-icon icon="ChevronLeftIcon" size="14" /> Volver
            </b-button>
            <div class="mb-1">
              <h6 class="wiz-label">Handle de YouTube</h6>
              <b-input-group prepend="@">
                <b-form-input
                  v-model="manualYoutube.username"
                  placeholder="micanal"
                  maxlength="100"
                  :state="youtubeChannelError ? false : null"
                  @input="youtubeChannelError = null"
                />
              </b-input-group>
            </div>
            <div class="mb-1">
              <h6 class="wiz-label">Suscriptores</h6>
              <cleave
                v-model="manualYoutube.followers"
                class="form-control"
                :raw="false"
                :options="options_number"
                placeholder="10,000"
              />
            </div>
            <b-alert v-if="youtubeChannelError" show variant="danger" class="mb-1 py-75 px-1 font-small-3">
              <feather-icon icon="AlertCircleIcon" size="14" class="mr-50" />
              {{ youtubeChannelError }}
            </b-alert>
            <b-button
              variant="primary"
              class="w-100"
              :disabled="!manualYoutube.username || !manualYoutube.followers || savingManual"
              @click="addYoutubeManual()"
            >
              <b-spinner v-if="savingManual" small class="mr-50" />
              Agregar cuenta
            </b-button>
          </div>
        </div>

        <div v-else>
          <div v-if="!addingManual" class="youtube-networks-list">
            <div
              v-for="network in youtubeNetworks"
              :key="network.uuid"
              class="youtube-network-card"
              :class="{ 'youtube-network-card--selected': selectedYoutubeNetwork === network.uuid }"
              @click="selectedYoutubeNetwork = selectedYoutubeNetwork === network.uuid ? null : network.uuid"
            >
              <b-avatar size="38" class="mr-1">
                <b-img :src="youtubeIcon" class="padding-07 youtube-border" fluid />
              </b-avatar>
              <div class="text-left overflow-hidden">
                <strong class="d-block text-truncate">{{ network.username || network.name || 'YouTube' }}</strong>
                <small class="text-muted text-truncate d-block">{{ network.url || network.profile_url || '' }}</small>
              </div>
              <feather-icon
                v-if="selectedYoutubeNetwork === network.uuid"
                icon="CheckCircleIcon"
                size="18"
                class="ml-auto text-success flex-shrink-0"
              />
            </div>
            <div class="yt-divider mt-2 mb-2"><span>agregar otra cuenta</span></div>
            <div class="d-flex" style="gap:10px">
              <b-button class="google-yt-btn" style="flex:1" @click="youtubeLoginWizard()">
                <b-img :src="googleIcon" class="google-yt-btn__icon" />
                <span>Google</span>
              </b-button>
              <b-button variant="outline-secondary" style="flex:1" @click="addingManual = true">
                <feather-icon icon="EditIcon" size="14" class="mr-50" />
                Manual
              </b-button>
            </div>
            <p v-if="oauthOpened" class="text-muted font-small-3 text-center mt-50 mb-0">
              Completa el proceso y después
              <b-link @click="refreshYoutubeNetworks()">recarga las cuentas</b-link>.
            </p>
          </div>
          <div v-else>
            <b-button variant="flat-secondary" size="sm" class="mb-1 p-0" @click="addingManual = false; youtubeChannelError = null">
              <feather-icon icon="ChevronLeftIcon" size="14" /> Volver
            </b-button>
            <div class="mb-1">
              <h6 class="wiz-label">Handle de YouTube</h6>
              <b-input-group prepend="@">
                <b-form-input
                  v-model="manualYoutube.username"
                  placeholder="micanal"
                  maxlength="100"
                  :state="youtubeChannelError ? false : null"
                  @input="youtubeChannelError = null"
                />
              </b-input-group>
            </div>
            <div class="mb-1">
              <h6 class="wiz-label">Suscriptores</h6>
              <cleave
                v-model="manualYoutube.followers"
                class="form-control"
                :raw="false"
                :options="options_number"
                placeholder="10,000"
              />
            </div>
            <b-alert v-if="youtubeChannelError" show variant="danger" class="mb-1 py-75 px-1 font-small-3">
              <feather-icon icon="AlertCircleIcon" size="14" class="mr-50" />
              {{ youtubeChannelError }}
            </b-alert>
            <b-button
              variant="primary"
              class="w-100"
              :disabled="!manualYoutube.username || !manualYoutube.followers || savingManual"
              @click="addYoutubeManual()"
            >
              <b-spinner v-if="savingManual" small class="mr-50" />
              Agregar cuenta
            </b-button>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-1">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('youtube')">{{$t('campaigns.close')}}</b-button>
          <b-button
            variant="primary"
            :disabled="!selectedYoutubeNetwork"
            @click="updateYoutube()"
          >
            {{$t('dashboard.save')}}
          </b-button>
        </div>
      </template>
    </modal-brandme>

    <modal-brandme size="xl" :show_modal="show_modal_invitation" :key="`modal_invitation_${change_modal_invitation}`">
      <template #title>{{$t('campaigns.changeLinkInvitation')}}</template>
      <template #body>
        <b-form-checkbox
          v-model="show_in_link"
          class="custom-control-primary text-left mt-1 mb-1"
        >
          {{$t('campaigns.showMessage')}}
        </b-form-checkbox>
        <b-form-group>
          <component
            :is="quill_editor"
            id="quil-content"
            v-model="custom_message"
            :options="editorOption"
            class="border-bottom-0 mw-100 h-150"
          />
          <div id="message-quill-toolbar" class="d-flex justify-content-end border-top-0">
            <!-- Add a bold button -->
            <button class="ql-bold" />
            <button class="ql-italic" />
            <button class="ql-underline" />
            <button class="ql-align" />
            <button class="ql-link" />
          </div>
        </b-form-group>
        <div class="d-flex justify-content-end mt-1">
          <b-button variant="outline-secondary" class="mr-1" @click="closeEdit('invitation')">{{$t('campaigns.close')}}</b-button>
          <b-button variant="primary" @click="updateMessagesInvitation()">{{$t('dashboard.save')}}</b-button>
        </div>
      </template>
    </modal-brandme>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormDatepicker,
  BInputGroup,
  BFormGroup,
  BFormCheckbox,
  BTooltip,
  BSpinner,
  BAvatar,
  BImg,
  BLink,
  BFormInput
} from "bootstrap-vue";
import ModalBrandme from "@/views/components/modal/ModalBrandme.vue";
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import { separatebycomma } from '@/libs/utils/formats'
import { hasPermission } from '@/libs/utils/user';
import othersService from '@/services/others'
import { getIconWhite, showToast } from '@/libs/utils/icons'
import { getUsernameUrlYoutube } from '@/libs/utils/urls'

export default {
  name: 'infoCampaign',
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormDatepicker,
    BInputGroup,
    BFormGroup,
    BFormCheckbox,
    BTooltip,
    BSpinner,
    BAvatar,
    BImg,
    BLink,
    BFormInput,
    ModalBrandme,
    Cleave,
    vSelect,
    InputTelBrandme: () => import('@/views/components/inputs/InputTelBrandme.vue'),
  },
  props: {
    campaign: {
      type: Object,
      default: () => {}
    },
    role: {
      type: String,
      default: ''
    },
    brands: {
      type: Array,
      default: () => []
    },
    disabled_update: {
      type: Boolean,
      default: false
    },
    is_editable_by_api: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      hasPermission,
      separatebycomma,
      brand_reference_name: this.campaign?.brand_reference?.name ?? '',
      init_date: this.campaign ? this.campaign.init_date : '',
      end_date: this.campaign ? this.campaign.end_date : '',
      budget: this.campaign ? this.campaign.budget : 0,
      options_number: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand'
      },
      brand: {title: this.$t('campaigns.selectBrand'), uuid: ''},
      custom_message: this.campaign.custom_message,
      show_in_link: this.campaign ? this.campaign.show_custom_message : true,
      show_modal_dates: false,
      change_modal_dates: 0,
      show_modal_budget: false,
      change_modal_budget: 0,
      show_modal_brand: false,
      change_modal_brand: 0,
      show_modal_whats: false,
      change_modal_whats: 0,
      state_telephone: false,
      country: this.campaign ? this.campaign?.country_whatsapp_manager : '',
      code: this.campaign ? this.campaign?.code_whatsapp_manager : '',
      whatsapp_manager:  this.campaign ? this.campaign?.whatsapp_manager ? this.campaign.whatsapp_manager : '' : '',
      show_modal_invitation: false,
      change_modal_invitation: 0,
      quill_editor: null,
      // YouTube
      show_modal_youtube: false,
      change_modal_youtube: 0,
      youtubeNetworks: [],
      selectedYoutubeNetwork: null,
      loadingYoutubeNetworks: false,
      addingManual: false,
      youtubeChannelError: null,
      oauthOpened: false,
      savingManual: false,
      manualYoutube: { username: '', followers: '' },
      youtubeIcon: getIconWhite('youtube'),
      googleIcon: require('@/assets/images/google/google.svg'),
    }
  },
  setup (props, context) {
    const editorOption = {
      modules: {
        toolbar: `#message-quill-toolbar`
      },
      placeholder: context.parent.$t('campaigns.writeHere')
    }
    return {
      editorOption
    }
  },
  computed: {
    // Solo usuarios con google_ycp pueden vincular el canal de YouTube a la campaña
    can_use_youtube() {
      return hasPermission('google_ycp')
    },
  },
  created() {
    if (this.campaign && this.campaign.brand_reference) {
      this.brand = {
        title: this.campaign.brand_reference.name,
        uuid: this.campaign.brand_reference.uuid,
      }
    }
  },
  async mounted() {
    const vue_quill_editor = (await import('vue-quill-editor'));
    this.quill_editor = vue_quill_editor.quillEditor;
  },
  methods: {
    updateTelephone(telephone_data) {
      console.log("entering here")
      this.whatsapp_manager = telephone_data.number;
      this.state_telephone = telephone_data.state;
      this.country = telephone_data.country;
      this.code = telephone_data.code;
    },
    validateBudget() {
      const maxBudget = 10000000;
      const enteredBudget = parseInt(this.budget.replace(/,/g, ''), 10);
      if (enteredBudget > maxBudget) {
        this.budget = '10,000,000';
      }
    },
    showEdit(modal) {
      this[`show_modal_${modal}`] = true
      this[`change_modal_${modal}`] += 1
    },
    closeEdit(modal) {
      this[`show_modal_${modal}`] = false
      this[`change_modal_${modal}`] += 1
    },
    openYoutubeModal() {
      if (!this.can_use_youtube) return
      this.addingManual = false
      this.oauthOpened = false
      this.manualYoutube = { username: '', followers: '' }
      this.fetchYoutubeNetworks()
      this.showEdit('youtube')
    },
    fetchYoutubeNetworks() {
      if (this.youtubeNetworks.length > 0) return
      this.loadingYoutubeNetworks = true
      othersService.getSocialNetworks('networks=youtube')
        .then(response => {
          this.youtubeNetworks = response.results || []
          if (this.youtubeNetworks.length === 1) {
            this.selectedYoutubeNetwork = this.youtubeNetworks[0].uuid
          }
        })
        .catch(() => {
          this.youtubeNetworks = []
        })
        .finally(() => {
          this.loadingYoutubeNetworks = false
        })
    },
    refreshYoutubeNetworks() {
      this.youtubeNetworks = []
      this.oauthOpened = false
      this.fetchYoutubeNetworks()
    },
    youtubeLoginWizard() {
      localStorage.setItem('network_code', 'youtube')
      const rootUrl = 'https://accounts.google.com/o/oauth2/v2/auth'
      const options = {
        client_id: process.env.VUE_APP_GOOGLE_ID,
        redirect_uri: process.env.VUE_APP_GOOGLE_CALLBACK,
        access_type: 'offline',
        response_type: 'code',
        prompt: 'consent',
        scope: 'https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly',
        hl: 'en'
      }
      window.open(`${rootUrl}?${new URLSearchParams(options).toString()}`, '_blank')
      this.oauthOpened = true
    },
    addYoutubeManual() {
      let username = this.manualYoutube.username.trim().replace(/^@/, '')
      if (!username || !this.manualYoutube.followers) return

      if (username.includes('youtube.com')) {
        const result = getUsernameUrlYoutube(username)
        username = result[0]
        if (!username) {
          this.youtubeChannelError = 'No se pudo extraer el handle de esa URL. Verifica e intenta de nuevo.'
          return
        }
      }

      this.youtubeChannelError = null
      this.savingManual = true
      const followers = parseInt(String(this.manualYoutube.followers).replace(/,/g, ''), 10)
      othersService.addSocialNetwork({ network: 'youtube', username, followers })
        .then(response => {
          if (response && response.code === 'accountNetwrokExists') {
            showToast(this, 'Cuenta ya registrada', 'Esta cuenta de YouTube ya está conectada.', 'AlertCircleIcon')
          } else if (response && response.code === 'youtube.channelDoesntExist') {
            this.youtubeChannelError = `No se encontró el canal "@${username}". Verifica el nombre de usuario e intenta de nuevo.`
          } else if (response && response.new) {
            this.addingManual = false
            this.manualYoutube = { username: '', followers: '' }
            this.youtubeChannelError = null
            this.youtubeNetworks = []
            this.fetchYoutubeNetworks()
          } else {
            this.youtubeChannelError = 'No se pudo agregar la cuenta. Intenta de nuevo.'
          }
        })
        .catch(() => {
          this.youtubeChannelError = 'No se pudo agregar la cuenta. Intenta de nuevo.'
        })
        .finally(() => {
          this.savingManual = false
        })
    },
    updateYoutube() {
      if (!this.can_use_youtube) return
      if (this.disabledUpdateCampaign() || !this.is_editable_by_api) return
      const network = this.youtubeNetworks.find(n => n.uuid === this.selectedYoutubeNetwork)
      if (!network?.username) return
      const formData = new FormData()
      formData.append('channel_brand_youtube', network.username)
      this.$emit('update_campaign', formData)
      this.closeEdit('youtube')
    },
    updateDates() {
      if (this.disabledUpdateCampaign()) return;

      const formData = new FormData()
      formData.append('init_date', this.init_date)
      formData.append('end_date', this.end_date)

      this.$emit('update_campaign', formData)
      this.closeEdit('dates')
    },
    updateBudget() {
      if (this.disabledUpdateCampaign()) return;
      const formData = new FormData()
      formData.append('budget', this.budget.replace(/,/g, ''))
      this.$emit('update_campaign', formData)
      this.closeEdit('budget')
    },
    updateBrand() {
      if (this.disabledUpdateCampaign() || !this.is_editable_by_api) return;
      const formData = new FormData()
      formData.append('brand_reference', this.brand.uuid)

      this.$emit('update_campaign', formData)
      this.closeEdit('brand')
    },
    updateWhatsApp() {
      if (this.disabledUpdateCampaign()) return;
      const data = {
        country_whatsapp_manager: this.country,
        code_whatsapp_manager: this.code,
        whatsapp_manager: this.whatsapp_manager
      }


      this.$emit('update_campaign', data)
      this.closeEdit('whats')
    },
    updateMessagesInvitation() {
      if (this.disabledUpdateCampaign()) return;
      const formData = new FormData()
      formData.append('custom_message', this.custom_message)
      formData.append('show_custom_message', this.show_in_link)
      this.$emit('update_campaign', formData)
      this.closeEdit('invitation')
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
  },
  watch: {
    '$i18n.locale'() {
      this.editorOption.placeholder = this.$t('campaigns.writeHere')
    }
  }
};
</script>

<style>
.youtube-networks-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.youtube-network-card {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.youtube-network-card:hover {
  border-color: #7046B6;
  background: #f8f4ff;
}
.youtube-network-card--selected {
  border-color: #7046B6;
  background: #f8f4ff;
}
.google-yt-btn {
  background: #fff !important;
  border: 1px solid #dadce0 !important;
  color: #3c4043 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  font-weight: 500;
  box-shadow: none !important;
}
.google-yt-btn:hover {
  background: #f8f9fa !important;
}
.google-yt-btn__icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.yt-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #aaa;
  font-size: 12px;
}
.yt-divider::before,
.yt-divider::after {
  content: '';
  flex: 1;
  border-top: 1px solid #e0e0e0;
}
.padding-07 {
  padding: 4px;
}
.youtube-border {
  border-radius: 4px;
  background: #ff0000;
}
.wiz-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6e6b7b;
  margin-bottom: 4px;
}
</style>
